<template>
  <div class="col-lg-6 col-md-12 col-xs-12 d-md-block d-none">
    <div class="imagecard">
      <img src="https://cdn.proxyscrape.com/img/support.png" alt="ProxyScrape support">
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="textcard">
      <h2>Outstanding support</h2>
      <br>
      <p>To help you with any product-related questions you might have,
        ProxyScrape provides live chat support from Sunday to Friday between 5 am and 10 pm EST.
        Outside the working hours, you can reach out to us via email,
        to which we will reply within 24 hours with a follow-up.
        <br><br>
        If you have any questions, please don't hesitate to reach out!
      </p>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-xs-12 d-md-none d-block">
    <div class="imagecard">
      <img src="https://cdn.proxyscrape.com/img/support.png" alt="ProxyScrape support">
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
